import { VF_RADIO_BUTTON } from 'AppSrc/core/components/forms/form-base-components/v-f-radio-button';
import {
  INLINE_ERRORS,
  commonValidation,
  cleanUpFieldErrors,
  getDefaultFieldErrors,
} from 'AppSrc/core/components/forms/form-base-components/utility/common-validation';

const fieldId = 'approver-list-radio-button';

const initialValues = null;


const vFParams = {
  fieldTitle: 'Please enter reason for cancellation',
  characterLimit: 250, // don't forget to add to validator
  placeholder: 'Approver Groups',
  displayType: 'big',
  formatDisplayOptions: ({ displayOptions }) => displayOptions.map((displayOption) => ({
    text: displayOption.text,
    value: displayOption.value.id,
  })),
  /* eslint-disable-next-line no-confusing-arrow */ // can't remember how to fix this and it aint confusing
  formatCurrentValue: ({ value }) => value ? value.id : null,
  parseSelectedValue: ({
    displayOptions,
    valueToSet,
  }) => {
    const formattedValueArr = displayOptions.filter((displayOption) => displayOption.value.id === valueToSet);
    const formattedValue = formattedValueArr[0] ? formattedValueArr[0].value : null;
    return formattedValue;
  },
};



const validator = (params) => {
  const {
    values,
    field,
  } = params;
  const {
    optional,
  } = field;

  /* MAKE A DEFAULT ERRORS OBJECT */
  const errors = getDefaultFieldErrors();

  /* ERROR CHECKERS */
  const noValue = commonValidation.noValue(values[fieldId], VF_RADIO_BUTTON);

  /* ADD ERRORS TO ERROR OBJECT */
  errors[INLINE_ERRORS].push((noValue && !optional) ? 'Please enter text' : null);

  /* REMOVE BLANK ERRORS (because Formik gets confused) */
  return cleanUpFieldErrors(errors);
};

const approverListRadioSelector = {
  id: fieldId,
  validator,
  initialValues,
  vFParams,
  fieldType: VF_RADIO_BUTTON,
};

export { approverListRadioSelector };

